<script setup lang="ts">
defineProps<{ clientIp?: string | null }>();
</script>

<template>
    <span
        class="inline-flex items-center gap-1.5 px-2 py-0.5 rounded text-xs font-medium
               bg-emerald-900/40 text-emerald-300 flex-shrink-0"
        :title="clientIp ? `On NetBird as ${clientIp}` : 'On NetBird'">
        <span class="w-1.5 h-1.5 rounded-full bg-emerald-400"></span>
        NetBird
    </span>
</template>
